<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 410.8 186.5"
    xml:space="preserve"
  >
    <!-- eslint-disable @stylistic/max-len -->
    <path
      style="fill-rule: evenodd;clip-rule: evenodd;fill: var(--black);"
      d="M77.4,0.5L4,40.5L85.5,88c0.7,0.4,1.6,1.3,1.6,2.2l0,69.9c0,1-0.9,1.6-1,1.7l-4.9,2.7  c-0.8,0.4-1.9,0.5-3-0.1l-4.3-2.4c-0.6-0.3-1.2-1.2-1.2-2.1V98c0-1.1-1.2-1.6-2-2.1L0,54.7v82.7c0,1.8,1.8,3.9,3.2,4.8l73.6,43.4  c2.4,1.4,3.8,1.2,7-0.5l72.7-42.9c1.7-1,3.3-2.9,3.3-4.9V54.7l-48.8,28.5c-0.6,0.4-1.7,0.5-2.4,0.1l-4.4-2.6  c-0.9-0.5-1.7-1.5-1.7-2.6l-0.1-5.2c0-0.8,0.5-1.8,1.2-2.2l52.2-30.4l-73.5-40C81.3-0.1,78.6-0.2,77.4,0.5L77.4,0.5z"
    />
    <g>
      <path
        style="fill: var(--black);"
        d="M261.2,137.2V39.9h-18.2v31.9c-1.7-1-9.1-2.3-15-2.2c-19.4,0.5-33.9,15.9-33.5,34.6   c0.5,24.5,15,34.8,37.6,36.2C243.9,141.3,257.8,137.7,261.2,137.2L261.2,137.2z M243.1,124c-1.2,0.3-9.1,1.1-12,0.6   c-12-1.9-17.7-8.1-17.9-18.7c-0.1-11.4,4.6-19.6,18.6-20.2c2.4-0.1,10.2,1.3,11.2,2.2L243.1,124L243.1,124z"
      />
      <path
        style="fill: var(--black);"
        d="M410.8,137.2V39.9h-18.2v31.9c-1.7-1-9.1-2.3-15-2.2c-19.4,0.5-33.9,15.9-33.5,34.6   c0.5,24.5,15,34.8,37.6,36.2C393.4,141.3,407.3,137.7,410.8,137.2L410.8,137.2z M392.7,124c-1.2,0.3-9.1,1.1-12,0.6   c-12-1.9-17.7-8.1-17.9-18.7c-0.1-11.4,4.6-19.6,18.6-20.2c2.4-0.1,10.2,1.3,11.2,2.2L392.7,124L392.7,124z"
      />
      <path
        style="fill: var(--black);"
        d="M271.5,75.4v91.3h18.4l-0.1-79.4c1.2-0.3,9-1.3,12-1.1c12.1,0.7,17.7,7.5,17.9,18.2   c0.2,6.8-2.1,12.5-6.5,16c-3.4,2.7-8,4-13.4,4.2l0,16c8.5,0.2,17-1.5,23.8-5.9c8.8-5.7,15.1-18.3,14.7-30.2   c-0.6-21.6-12.8-34-37.6-34.5C289.1,69.5,275,73.6,271.5,75.4L271.5,75.4z"
      />
    </g>
  </svg>
</template>
